<div class="header">

    <a class="logo" routerLink="/">
        <img src="../assets/logo.png" alt="WAGAS - Handlowcy">
        <span>Sales Support System</span>
    </a>

</div>
<ns-template-window>
    <div class="main">
        <div class="information-box">
            <form (ngSubmit)="onSubmit()" [formGroup]="form">
                <h1>Zapomniałem hasła</h1>
                <div class="description">
                    Podaj adres e-mail, na który wyślemy link aktywacyjny z ustawieniem nowego hasła.
                </div>
                <cmn-label labelText="Adres e-mail:" labelPosition="top" labelWidth="100%">
                    <input formControlName="email" autocomplete="off" kendoTextBox/>
                    <cmn-errors [control]="form.get('email')"></cmn-errors>
                </cmn-label>
                <div class="action-row">
                    <button type="submit" kendoButton [primary]="false" class="mid">
                        Wyślij prośbę o reset hasła
                    </button>
                </div>
            </form>
        </div>
    </div>
</ns-template-window>

